import { render, staticRenderFns } from "./InformationAboutClassesInClub.vue?vue&type=template&id=b57a83c4&"
import script from "./InformationAboutClassesInClub.vue?vue&type=script&lang=js&"
export * from "./InformationAboutClassesInClub.vue?vue&type=script&lang=js&"
import style0 from "./InformationAboutClassesInClub.vue?vue&type=style&index=0&id=b57a83c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports